var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-invoice',{staticClass:"pt-invoice__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }